import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  UFDate,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import PaymentMode from "../../../components/Common/chooseFields/paymentMode"
import LoadingButton from "../../../components/Common/LoadingButton"
import Location from "../../../components/Common/chooseFields/location"
import lightTrash from "../../../assets/icons/light-trash.svg"
import Priority from "../../../components/Common/chooseFields/priority"
import {
  fetchMRRequest,
  fetchRequest,
  postMaterialRequest,
  postMaterialRequestFinance,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import Productcode from "../../../components/Common/chooseFields/Product"
import { fetchProjecrtMaster } from "../../../services/projectManager/projectMaster"
import MaterialProjectNo from "../../../components/Common/chooseFields/materailProject"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import MaterialProductList from "../../../components/Common/chooseFields/materialProductList"
import { useSelector } from "react-redux"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getCode } from "../../../services/inventory"
import { p } from "@table-library/react-table-library/styles-492c6342"
import NumberFormat from "../../../utils/numberFormat"

const schema = yup.object().shape({
  project_code: yup.mixed().required("project code is required"),
  request_date: yup
    .mixed()
    .required("Request Date is required")
    .test(
      "is-future-date",
      "Make sure the request date is forward-looking",
      function (value) {
        if (!value) return true
        const currentDate = moment()
        const selectedDate = moment(value)
        return selectedDate.isSameOrAfter(currentDate, "day")
      }
    ),
  exp_Delivery_date: yup
    .mixed()
    .test(
      "is-future-date",
      "Make sure the exp delivery date is forward-looking",
      function (value) {
        if (!value) return true
        const currentDate = moment()
        const selectedDate = moment(value)
        return selectedDate.isSameOrAfter(currentDate, "day")
      }
    )
    .required("Delivery Date is required"),
  // requested_by: yup.string().required("requested by is required"),
  // contact_number: yup
  //   .string()
  //   .matches(/^([+]?)?[0-9]+$|^$/, "Mobile no must be only digits")
  //   .required("contact number is required"),
  material_req: yup.array().of(
    yup.object().shape({
      product_id: yup.mixed().required("product code is required"),
      // description: yup.string().required("description is required"),
      // priority: yup.mixed().required("priority is required"),
      // quantity: yup
      //   .string()
      //   .matches(
      //     /^(?!0+(\.0+)?$)\d*(\.\d+)?$/,
      //     "Quantity must be a non-negative number and cannot be zero"
      //   )
      // .test(
      //   "max",
      //   "Received quantity must not exceed the ordered quantity",
      //   function (value) {
      //     const { initial_quantity } = this.parent
      //     const { received_quantity } = this.parent
      //     const validateqty = initial_quantity - received_quantity
      //     return parseInt(value) <= validateqty
      //   }
      // )
      // .required("Quantity is required"),
      // requestquantity: yup
      //   .string()
      //   .matches(
      //     /^(?!0+(\.0+)?$)\d*(\.\d+)?$/,
      //     "Requested Quantity must be a non-negative number and cannot be zero"
      //   )
      //   .test(
      //     "not-greater-than-quantity",
      //     "Requested quantity cannot be greater than available quantity",
      //     function (value) {
      //       const quantity = parseFloat(this.parent.quantity || 0)
      //       const initialQuantity = parseFloat(
      //         this.parent.initial_quantity || 0
      //       )
      //       const receivedQuantity =
      //         parseFloat(initialQuantity || 0) - parseFloat(quantity || 0)
      //       const requestquantity = parseFloat(value || 0)
      //       return requestquantity <= receivedQuantity
      //     }
      //   ),
      requestquantity: yup
        .number()
        .typeError("Requested Quantity must be a number")
        .min(0, "Requested Quantity cannot be negative")
        .test(
          "not-greater-than-quantity",
          "Requested quantity cannot be greater than available quantity",
          function (value) {
            const quantity = parseFloat(this.parent.quantity || 0)
            const initialQuantity = parseFloat(
              this.parent.initial_quantity || 0
            )
            const receivedQuantity =
              parseFloat(initialQuantity) - parseFloat(quantity)
            return value <= receivedQuantity
          }
        ),
    })
  ),
})

const EditMaterialRequest = ({ fromDashboard, projectValue, toggle }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Material Request${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`
  const navigate = useNavigate()
  const desimalrange = localStorage.getItem("desimalrange")
  const { id } = useParams()
  const now = moment()
  const [isLoading, setIsLoading] = useState(false)
  const [isDraftLoading, setIsDraftLoading] = useState(false)
  const [projectID, setProjectID] = useState()
  const [action, setAction] = useState()
  const [materialsData, setMaterialsData] = useState([])

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      project_code: null,
      contact_number: "",
      requested_by: "",
      code_edit: 0,
      request_date: moment(now, "YYYY-MM-DD").toDate(),
      delivery_location: null,
      material_req: [
        {
          id: "",
          product_id: null,
          quantity: "",
          requestquantity: "",
          description: "",
          // priority: null,
          initial_quantity: "",
          received_quantity: "",
        },
      ],
    },
  })
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   shouldFocusError: true,
  // })
  const {
    fields: materialFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "material_req",
  })

  const handleRegistration = async data => {
    // const Requestarray = data?.material_req?.map(dt => ({
    //   project_material_id: dt?.id,
    //   material_id: dt?.product_id?.value,
    //   // priority: dt?.priority?.value,
    //   // description: dt?.description,
    //   requested_quantity: dt?.requestquantity,
    //   // unit_id: dt?.unit_id,
    // }))
    const Requestarray = data?.material_req
      ?.filter(dt => Number(dt?.requestquantity) > 0)
      .map(dt => ({
        project_material_id: dt?.id,
        material_id: dt?.product_id?.value,
        // priority: dt?.priority?.value,
        // description: dt?.description,
        requested_quantity: dt?.requestquantity,
        // unit_id: dt?.unit_id,
      }))
    try {
      action === 1 ? setIsDraftLoading(true) : setIsLoading(true)
      const update = await postMaterialRequestFinance({
        ...data,
        save_as_draft: action == 1 ? 0 : 1,
        requested_by: loggedUser?.data?.id,
        contact_number: 0,
        delivery_location: data?.delivery_location,
        project_id: data?.project_code?.value,
        materials: Requestarray,
        exp_Delivery_date: moment(data?.exp_Delivery_date).format("YYYY-MM-DD"),
        request_date: moment(data?.request_date).format("YYYY-MM-DD"),
      })
      if (fromDashboard) {
        toggle()
      } else {
        navigate("/project-materialreq")
      }
      toastSuccess(update?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setIsDraftLoading(false)
    }
  }

  const handleProjectChange = () => {
    const { project_code } = getValues()
    fetchProjectData(project_code?.value)
    setProjectID(project_code?.value)
  }

  useEffect(() => {
    if (fromDashboard) {
      setValue("project_code", projectValue)
      fetchProjectData(id)
      setProjectID(id)
    }
    const fetchMrEdit = async id => {
      const responce = await fetchMRRequest(id)
      console.log(`responce edit`, responce)
      const materialsArr = responce?.data?.materials?.map(dt => ({
        product_id: {
          label: `${dt?.product?.product_code} - ${dt?.product?.description}`,
          value: dt?.product?.id,
        },
        quantity:
          Number(dt?.used_quantity) > 0 ? dt?.used_quantity : 0,
        requestquantity: Number(dt?.requested_quantity).toFixed(desimalrange),
        description: dt?.product?.description,
        initial_quantity: dt?.product?.requestedCount,
      }))
      // setMaterialsData(materialsArr)
      reset({
        ...responce?.data,
        project_code: {
          label: responce?.data?.project?.project_code,
          value: responce?.data?.project?.id,
        },
        project_name: responce?.data?.project?.project_name,
        exp_Delivery_date: responce?.data?.exp_Delivery_date,
        material_req: materialsArr,
      })
    }
    const getUniqueCode = async (code, modal, type) => {
      const response = await getCode(code, modal, type)
      if (!id) {
        setValue("code", response?.code?.code)
      }
      setValue("code_edit", response?.code?.manualoverride)
    }
    if (id) {
      fetchMrEdit(id)
    }
    // if (!id) {
    getUniqueCode("code", "NewMaterialRequest", "NewMaterialRequest")
    // }
  }, [fromDashboard, id])

  const fetchProjectData = async idData => {
    const response = await fetchProjecrtMaster(idData)
    console.log("responsehaha", response)
    if (idData == response.data?.id) {
      const Requestarray = response.data?.project_material
        ?.map(dt => {
          const projectMrQuantitySum = dt.project_mr.reduce(
            (total, mr) => total + parseFloat(mr.quantity),
            0
          )

          const alreadyReceived =
            dt.material_request_materials_sum_requested_quantity
              ? dt.material_request_materials_sum_requested_quantity
              : 0
          const balanceQty =
            dt.material_request_materials_sum_requested_quantity
              ? Number(dt?.quantity) - Number(alreadyReceived)
              : 0
          const quantity = dt.material_request_materials_sum_requested_quantity
            ? alreadyReceived
            : 0
          return {
            id: dt?.id,
            product_id: {
              value: dt?.product_code?.id,
              label: `${dt?.product_code?.product_code} - ${dt?.product_code?.description}`,
              storeCount: dt?.products?.storeCount,
            },
            description: dt?.product_code?.description,
            quantity: Number(quantity).toFixed(desimalrange),
            initial_quantity: dt?.quantity,
            created_qty: dt.material_request_materials_sum_requested_quantity,
            received_quantity: balanceQty,
            unit_id: dt?.unit?.id,
            requestquantity: (Number(dt?.quantity) - Number(alreadyReceived)).toFixed(desimalrange),
          }
        })
        .filter(
          item => Number(item.initial_quantity) - Number(item.created_qty) !== 0
        )
      const previousDatas = getValues()
      setMaterialsData(Requestarray)
      reset({
        ...previousDatas,
        project_name: response.data?.project_name,
        material_req: Requestarray,
        delivery_location: response.data?.location?.name,
      })
    }
  }
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-2">
                  {!fromDashboard ? (
                    <Breadcrumbs
                      title="Project Management"
                      breadcrumbObject={[
                        { title: "Project Management", link: "/project" },
                        { title: crumb || "Masters", link: "/project" },
                        {
                          title: "Material Request",
                          link: "/project-materialreq",
                        },
                        {
                          title: id
                            ? "Edit Material Request"
                            : "Add Material Request",
                          link: "",
                        },
                      ]}
                    />
                  ) : (
                    <div></div>
                  )}
                  <div>
                    <LoadingButton
                      type="submit"
                      color="primary"
                      className="btn-sm btn-rounded waves-effect waves-light mb-3"
                      onClick={() => setAction(1)}
                      loading={isDraftLoading}
                    >
                      {id ? "Update As Draft" : "Save As Draft"}
                    </LoadingButton>
                    {/* <LoadingButton
                      form={`request-form`}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      onClick={() => setAction(2)}
                      className={"px-2 mb-3 ms-2 me-1 btn btn-primary"}
                      type="submit"
                    >
                      {fromDashboard ? "Save" : id ? "Update" : "Save"}
                    </LoadingButton> */}
                  </div>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="mb-1 mt-2">
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>MR Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"code"}
                          invalid={!!errors.code}
                          disabled={
                            watch("code_edit") == 0 ||
                            watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Project Code<span className="mandatory">*</span>
                        </Label>
                        <MaterialProjectNo
                          control={control}
                          placeholder="Select the project code"
                          name={"project_code"}
                          target={fromDashboard ? ".modal" : "body"}
                          onSelectChange={handleProjectChange}
                          invalid={!!errors.project_code}
                          disabled={fromDashboard}
                          is_budgeted={1}
                          is_mr={1}
                        />
                        <FormFeedback invalid>
                          {errors.project_code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Request Date <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"request_date"}
                          invalid={!!errors.request_date}
                        />
                        <FormFeedback invalid>
                          {errors.request_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Exp. Delivery Date{" "}
                          <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"exp_Delivery_date"}
                          invalid={!!errors.exp_Delivery_date}
                        />
                        <FormFeedback invalid>
                          {errors.exp_Delivery_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr className="m-0" />
                  <Row className="py-2 mt-1">
                    <h5 className="edittheamtitle">Material Details</h5>
                  </Row>
                  <Row className="mb-4">
                    <Col lg={12}>
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Product Code</th>
                            <th>Total Quantity</th>
                            <th>Requested Quantity</th>
                            <th>Quantity</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {materialFields.map((item, index) => (
                            <tr key={`materialFields_${item?.id || index}`}>
                              <td className="ps-1">
                                <MaterialProductList
                                  control={control}
                                  placeholder="Product Code"
                                  projectid={projectID}
                                  selectedProduct={watch(`material_req`)}
                                  index={index}
                                  name={`material_req.${index}.product_id`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.product_id
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.product_id
                                      ?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-2">
                                <UFInput
                                  control={control}
                                  placeholder="Quantity"
                                  name={`material_req.${index}.initial_quantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]
                                      ?.initial_quantity
                                  }
                                  disabled
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]
                                      ?.initial_quantity?.message
                                  }
                                </FormFeedback>
                              </td>

                              <td className="ps-1">
                                <UFInput
                                  control={control}
                                  placeholder="Quantity"
                                  name={`material_req.${index}.quantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]?.quantity
                                  }
                                  disabled
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.quantity
                                      ?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-1">
                                <UFInputNumber
                                  control={control}
                                  placeholder="Quantity"
                                  name={`material_req.${index}.requestquantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]
                                      ?.requestquantity
                                  }
                                  isDecimal={true}
                                  maxNum={
                                    watch(
                                      `material_req.${index}.initial_quantity`
                                    )
                                      ? Number(
                                          watch(
                                            `material_req.${index}.initial_quantity`
                                          )
                                        ) -
                                        Number(
                                          watch(
                                            `material_req.${index}.quantity`
                                          ) || 0
                                        )
                                      : 0
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]
                                      ?.requestquantity?.message
                                  }
                                </FormFeedback>
                              </td>
                             
                              <td>
                                <div className="pb-1 px-2 d-flex justify-content-center">
                                  <div
                                    className="trash-img pointer"
                                    onClick={() => materialRemove(index)}
                                  >
                                    <TrashIcon />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {!fromDashboard &&
                        watch("project_code") != null &&
                        materialsData?.length != materialFields?.length && (
                          <Col
                            lg="12"
                            xs={12}
                            md={2}
                            sm={12}
                            className="d-flex justify-content-end"
                          >
                            <Button
                              color="primary"
                              className="addButton mt-2"
                              onClick={() =>
                                materialAppend({
                                  product_id: "",
                                  description: "",
                                  quantity: "",
                                  requestquantity: "",
                                })
                              }
                            >
                              + Row
                            </Button>
                          </Col>
                        )}
                    </Col>
                  </Row>
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditMaterialRequest
